import { IDataTableColumn } from 'react-data-table-component';

import { Button, Typography } from '@mui/material';

import Delete from '@mui/icons-material/Delete';

import StatusCell from '../../../sharedModules/layout/StatusCell';

import { BackflowJobGroup } from '../../model';

const WaterAuthorityCell = ({ row }: { row: BackflowJobGroup }) => {
  if (row?.water_authority_name === 'Unknown') {
    return (
      <div data-tag="___react-data-table-allow-propagation___">
        <StatusCell status="unknown" />
      </div>
    );
  }
  
  return (
    <div data-tag="___react-data-table-allow-propagation___" style={{ fontSize: '12px' }}>
      {row?.water_authority_name}
    </div>
  );
};

export const backflowJobGroupsColumns = (
  handleDelete?: (item: BackflowJobGroup) => void,
  includeWaterAuthority: boolean = false,
): IDataTableColumn<BackflowJobGroup>[] => {
  const baseColumns: IDataTableColumn<BackflowJobGroup>[] = [
    {
      name: 'Scheduled',
      selector: 'schedule_dates',
      sortable: true,
    },
    {
      name: 'Order',
      selector: 'order_no',
      sortable: true,
    },
    {
      name: 'Customer',
      selector: 'company_name',
      sortable: true,
    },
    {
      name: 'Address',
      selector: 'address',
      grow: 2,
      sortable: true,
    },
    {
      name: 'Water Authority',
      selector: 'water_authority_name',
      sortable: true,
      omit: !includeWaterAuthority,
      cell: (row) => <WaterAuthorityCell row={row} />,
    },
    {
      name: 'Asset Count',
      selector: 'asset_count',
      sortable: true,
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: true,
      omit: includeWaterAuthority,
      cell: (row) => <StatusCell status={row.status} />,
    },
    {
      name: 'Actions',
      selector: 'actions',
      grow: 0.5,
      cell: (row) => (
        <Button variant="contained" color="warning" onClick={() => handleDelete(row)} disabled={!row.allow_delete}>
          <Delete />
        </Button>
      ),
    },
  ];

  return baseColumns;
};
